import styled from "styled-components";

export const _CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 10px;
  border: none;
  background: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
`;

export const _Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 10px 10px;
`;
